import { Link as ReactLink } from 'react-router-dom';
import {
  Icon,
  Text,
  Link,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Box,
} from '@chakra-ui/react';
import {
  GiBeveledStar,
  GiTwirlyFlower,
  GiLotusFlower,
  GiHighGrass,
} from 'react-icons/gi';

const NavBreadCrumb = () => {
  return (
    <Box mt={8}>
      <Breadcrumb
        separator={<Icon as={GiHighGrass} w={6} h={6} color="green.300" />}
      >
        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/">
              <Text as="i" fontSize="sm">
                Home
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/about">
              <Text as="i" fontSize="sm">
                About
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/marketplace">
              <Text as="i" fontSize="sm">
                Marketplace
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/auctions">
              <Text as="i" fontSize="sm">
                Auction House
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/dreamstudio">
              <Text as="i" fontSize="sm">
                Dream Studio
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/gamenfts">
              <Text as="i" fontSize="sm">
                Game NFTs
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/gamelist">
              <Text as="i" fontSize="sm">
                Game Showcase
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/user">
              <Text as="i" fontSize="sm">
                User
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>
            <Link as={ReactLink} to="/faq">
              <Text as="i" fontSize="sm">
                FAQ
              </Text>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
    </Box>
  );
};

export default NavBreadCrumb;
